import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventResponse} from "../../../model/response/event/event-response.model";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {EventService} from "../../../../service/api/event.service";
import {MessageToastService} from "../../../../service/message-toast.service";
import {finalize, tap} from "rxjs";
import {ApiResponse} from "../../../model/response/ApiResponse";
import {ErrorMessageEnum} from "../../../enums/error-message.enum";

@Component({
    selector: 'app-event-treatment-modal',
    templateUrl: './event-treatment-modal.component.html',
    standalone: false
})
export class EventTreatmentModalComponent implements OnInit {

  @Input('event') event: EventResponse
  @Input('display') displayModal: boolean

  @Output('onEventTreatmentSuccess') onEventTreatmentSuccess = new EventEmitter<any>()
  @Output('onCancelModal') onCancelModal = new EventEmitter()

  form: FormGroup

  decisionError: string = null
  motiveError: string = null

  isLoading = false;

  decisions: { code?: string, description?: string }[] = [
    {code: '', description: ''},
    {code: 'YES', description: 'Sim'},
    {code: 'NO', description: 'Não'}
  ]

  constructor(
    private eventService: EventService,
    private messageToast: MessageToastService,
  ) {
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      "decision": new FormControl(null, Validators.required),
      "motive": new FormControl(null, Validators.required),
    });
  }

  onSubmit() {

    this.decisionError = null
    this.motiveError = null

    if (this.form.invalid) {
      this.validateFormErrors()
    } else {
      this.isLoading = true
      this.apiActivateEvent()
    }
  }

  apiActivateEvent() {
    const formValue = this.form.value
    formValue.decision = this.form.value == "YES"

    this.eventService.activateEvent(this.event.id, formValue).pipe(
      finalize(() => this.isLoading = false),
      tap({
        next: value => {
          this.messageToast.success(value.message)
          this.onEventTreatmentSuccess.emit()
          this.onCancelModal.emit()
        },
        error: (err: ApiResponse<any>) => {
          this.messageToast.error(err?.message)

          if (err?.formErrors) {
            this.decisionError = err.formErrors.get("decision")
            this.motiveError = err.formErrors.get("motive")
          }
        }
      })).subscribe()
  }

  validateFormErrors() {
    if (this.form.invalid) {
      if (this.form.get("decision")?.hasError("required")) {
        this.decisionError = ErrorMessageEnum.requiredField
      }

      if (this.form.get("motive")?.hasError("required")) {
        this.motiveError = ErrorMessageEnum.requiredField
      }
    }
  }
}
